// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // API_URL : "http://localhost:8000/",
  // DOWNLOAD_URL : "http://localhost:8000/",
  API_URL : "https://soulspacecare.com/api_v1/",
  MEDIA_URL :"https://soulspacecare.com/api_v1/",
  APPOINTMENT_URL :"https://soulspacecare.com/api_v1/",

  DOWNLOAD_URL : "https://uatcmsbackend.stemzglobal.com:3000/",
  ATTUNE_API_URL : "https://stemz.attunelive.net/LIMSAPI/api/",

  //API_URL : "http://demo.lifotechnologies.com:8001/",
  SKIP_LOCATION_CHANGE:false,
  JBPM_URL : "http://192.168.1.19:8090/",
  JBPM_STATUS:false,
  JBPM_CONTAINER_ID:'glosys-kjar-1_0-SNAPSHOT',
  JBPM_USER:'glosys',
  JBPM_PASSWORD:'glosys',
  CRYPTO_KEY:'wHLHsHeTcFvW11LBjnE4tE6sz',
  SECUGEN_QUALITY: {Timeout:'10000',Quality:'100',licstr:'',templateFormat:'ISO'},
  SECUGEN_CAPTURE : 'https://localhost:8443/SGIFPCapture',
  SECUGEN_MATCH: "https://localhost:8443/SGIMatchScore",
  DEFAULT_LANG: localStorage.getItem('defaultLang')?localStorage.getItem('defaultLang'):'en',
  SUCCESS_CODE: 1,
  ERROR_CODE : 2,
  DATE_FORMAT:'DD/MM/YYYY',
  DATE_FORMAT_REVERSE:'YYYY-MM-DD',
  DATETIME_FORMAT:'DD/MM/YYYY hh:mm:ss A',
  TOKENACCESS:false,
  SECRET_KEY:'V1VWTVRFOVhJRk5WUWsxQlVrbE9SUT09LFRrOUNUMFJaSUZkSlRFd2dTMDVQVnc9PQ==',
  FREEDOM_NANO:'http://localhost:8880/Freedom/ModalityWorklist/',
  TESTING_STATUS:false,
  VITALS_KIOSK:"http://localhost:5000/listener",
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
